import React, { useState, useEffect } from 'react';
import { Card, Input, Button, Spin, Alert, Space, Typography } from 'antd';
import { SearchOutlined, UserOutlined } from '@ant-design/icons';
import { getLeadById } from '../services/apiService';
import authService from '../services/authService';
import DynamicLeadDetails from './DynamicLeadDetails';

const { Title, Text } = Typography;

export default function LeadDetailsById() {
  const [leadId, setLeadId] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [leadData, setLeadData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    // Get current user and company ID
    const fetchUser = async () => {
      try {
        const user = await authService.getUserDetails();
        setCurrentUser(user);
        if (user?.company_id) {
          setCompanyId(user.company_id);
        }
      } catch (err) {
        console.error('Error fetching user:', err);
      }
    };
    fetchUser();
  }, []);

  const handleSearch = async () => {
    if (!leadId.trim()) {
      setError('Please enter a Lead ID');
      return;
    }

    if (!companyId.trim()) {
      setError('Company ID is required');
      return;
    }

    setLoading(true);
    setError(null);
    setLeadData(null);

    try {
      console.log('Fetching lead details for:', { companyId, leadId });
      const data = await getLeadById(companyId, leadId.trim());
      
      console.log('Lead data received:', data);
      console.log('Available fields:', Object.keys(data));
      
      setLeadData(data);
    } catch (err) {
      console.error('Error fetching lead:', err);
      setError(err.message || 'Failed to fetch lead details');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto', padding: '20px' }}>
      <Card>
        <Title level={3}>
          <SearchOutlined /> Lead Details by ID
        </Title>
        <Text type="secondary">
          Enter a Lead ID to view detailed information
        </Text>

        <div style={{ marginTop: 24, marginBottom: 24 }}>
          <Space size="middle" wrap>
            <div>
              <Text strong>Company ID:</Text>
              <Input
                placeholder="Enter Company ID"
                value={companyId}
                onChange={(e) => setCompanyId(e.target.value)}
                style={{ width: 200, marginLeft: 8 }}
              />
            </div>
            <div>
              <Text strong>Lead ID:</Text>
              <Input
                placeholder="Enter Lead ID"
                value={leadId}
                onChange={(e) => setLeadId(e.target.value)}
                onPressEnter={handleSearch}
                style={{ width: 200, marginLeft: 8 }}
              />
            </div>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={handleSearch}
              loading={loading}
            >
              Get Lead Details
            </Button>
          </Space>
        </div>

        {error && (
          <Alert
            message="Error"
            description={error}
            type="error"
            showIcon
            style={{ marginBottom: 24 }}
          />
        )}

        {loading && (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <Spin size="large" />
            <div style={{ marginTop: 16 }}>Loading lead details...</div>
          </div>
        )}

        {leadData && !loading && (
          <DynamicLeadDetails leadData={leadData} />
        )}

        {!leadData && !loading && !error && (
          <Alert
            message="No Lead Data"
            description="Enter a Lead ID and click 'Get Lead Details' to view lead information"
            type="info"
            showIcon
            style={{ marginTop: 24 }}
          />
        )}
      </Card>
    </div>
  );
}